import { render, staticRenderFns } from "./ValidSummernote.vue?vue&type=template&id=69acbb2b&scoped=true&"
import script from "./ValidSummernote.vue?vue&type=script&lang=js&"
export * from "./ValidSummernote.vue?vue&type=script&lang=js&"
import style0 from "./ValidSummernote.vue?vue&type=style&index=0&id=69acbb2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69acbb2b",
  null
  
)

export default component.exports